export default () => window.localStorage.getItem('token')



// WEBPACK FOOTER //
// ./src/view/login/brain/CheckAuth.js